import { render } from "./PriceListCompareDialog.vue?vue&type=template&id=60e70fc3&scoped=true"
import script from "./PriceListCompareDialog.vue?vue&type=script&lang=js"
export * from "./PriceListCompareDialog.vue?vue&type=script&lang=js"

import "./PriceListCompareDialog.vue?vue&type=style&index=0&id=60e70fc3&scoped=true&lang=css"
import "./PriceListCompareDialog.vue?vue&type=style&index=1&id=60e70fc3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e70fc3"]])

export default __exports__